// extracted by mini-css-extract-plugin
module.exports = {"root":"OmXqSbf5","textWrapper":"GdYeSYtE","title":"P8x4ag6h","viewPastNotificationsButton":"pTtMIdPK"};